import { render } from "./aic_view.html?vue&type=template&id=56c6ee20&external"
import script from "./aic_view.js?vue&type=script&lang=js&external"
export * from "./aic_view.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__